import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

/**
 * The way out of the two dead ends a partner who skipped the OTP can hit: "User is not
 * confirmed" on sign-in, and "An account with this email already exists" on re-signup.
 *
 * Styled as a secondary (outlined) button on purpose. On both screens it sits near the
 * primary action — "Log In", "Send OTP" — and a second solid orange button would compete
 * with it. Outlined keeps the primary action obvious while still reading as a button rather
 * than the underlined text link this replaced, which was easy to miss in a red error box.
 */
function VerifyEmailCta({ email = "", label = "Verify my email", style = {} }) {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);

  const target = email
    ? `/verify-email?email=${encodeURIComponent(email)}`
    : "/verify-email";

  return (
    <button
      type="button"
      onClick={() => navigate(target)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setHovered(true)}
      onBlur={() => setHovered(false)}
      style={{
        width: "100%",
        // 46px total height: comfortably above the 44px minimum touch target.
        padding: "12px 16px",
        borderRadius: "30px",
        border: "2px solid #DE810E",
        background: hovered ? "#FDF1E1" : "transparent",
        color: "#DE810E",
        fontWeight: "bold",
        fontSize: "1rem",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        transition: "background 0.2s ease",
        ...style,
      }}
    >
      {label}
      {/* Nudges right on hover — a small directional cue that this navigates away. */}
      <span
        aria-hidden="true"
        style={{
          transform: hovered ? "translateX(3px)" : "translateX(0)",
          transition: "transform 0.2s ease",
        }}
      >
        →
      </span>
    </button>
  );
}

export default VerifyEmailCta;
